import CardModifier from './CardModifier';
import GameObject from '../../../../GameObject/GameObject';
import Armature from '../../../Armature';

export default class BombModifier extends CardModifier {
    protected onCreate(params: any): void {
        super.onCreate(params);

        const animationName = [
            'explosion',
            'countdown1',
            'countdown2',
            'countdown3',
            'countdown4',
            'countdown5',
        ][params.properties.timer || 5];

        const bombArmature = GameObject.Instantiate(Armature, {
            name: 'bombContainer',
            dragonbonesName: 'CardsVFX',
            armatureName: 'BombCard_Overlay',
            animationName: animationName,
        });

        this.addChild(bombArmature);
    }
}
